import React from "react";
import Card from "react-bootstrap/Card";

export default class SiteSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { tableRowObjects: [] };
  }

  toggle(companyId) {
    let rows = this.state.tableRowObjects;
    let toggleRow = rows.find(r => r.companyId === companyId);
    toggleRow.toggled = !toggleRow.toggled;
    this.setState({ tableRowObjects: rows });
  }

  componentDidMount() {
    this.setState({ tableRowObjects: this.buildRows() });
  }

  getQueueColor(minutes) {
    if (minutes === 0.0) {
      return { backgroundColor: "#66e066" };
    } else if (minutes > 250.0 && minutes < 1000.0) {
      return { backgroundColor: "#ffff80" };
    } else if (minutes >= 1000.0) {
      return { backgroundColor: "#ff9090" };
    }
  }

  getQaNumColor(num) {
    if (num === 0) {
      return { backgroundColor: "#66e066" };
    } else if (num > 10 && num < 25) {
      return { backgroundColor: "#ffff80" };
    } else if (num > 25) {
      return { backgroundColor: "#ff9090" };
    }
  }

  buildRows() {
    const { admin } = this.props;
    let rows = [];

    for (let companyRow of this.props.siteSummary) {
      let row = {};
      const companyId = companyRow.company_id;

      row["companyId"] = companyId;
      row["main"] = (
        <tr key={companyId}>
          <td>
            {admin && (
              <a href={"/contractor_users/scoring/" + companyId}>
                {companyRow.company_name}
              </a>
            )}
            {!admin && companyRow.company_name}
          </td>
          <td>{Math.round(companyRow.total_t)}</td>
          <td style={this.getQueueColor(parseFloat(companyRow.total_q))}>
            {Math.round(companyRow.total_q)}
          </td>
          <td>{Math.round(companyRow.total_s)}</td>
          <td>
            <button onClick={() => this.toggle(companyId)}>
              {"Toggle " + companyRow.call_types.length}
            </button>
          </td>
        </tr>
      );
      row["toggled"] = false;
      row["subRows"] = companyRow.call_types.map(callType => {
        return (
          <tr key={callType.name}>
            <td className="subRow">{callType.name}</td>
            <td>{Math.round(callType.being_t)}</td>
            <td style={this.getQueueColor(parseFloat(callType.on_q))}>
              {Math.round(callType.on_q)}
            </td>
            <td>{Math.round(callType.being_s)}</td>
            <td>-</td>
          </tr>
        );
      });

      rows.push(row);
    }

    return rows;
  }

  render() {
    const { admin, callbackSchedulingQaNum } = this.props;
    const { tableRowObjects } = this.state;

    let tableRows = [];

    for (let rowObject of tableRowObjects) {
      tableRows.push(rowObject.main);
      if (rowObject.toggled) {
        tableRows = tableRows.concat(rowObject.subRows);
      }
    }

    return (
      <Card body>
        <h1 className="large">Site Summary</h1>
        <table className="table">
          <thead>
            <tr>
              <th>Company:</th>
              <th>Minutes Being Transcribed:</th>
              <th>Minutes On Queue:</th>
              <th>Minutes Being Scored:</th>
              <th>Call Types:</th>
            </tr>
          </thead>
          <tbody>{tableRows}</tbody>
        </table>
        {admin && (
          <table className="table">
            <thead>
              <tr>
                <th>QA Type</th>
                <th>Remaining</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Callback Scheduling QA</td>
                <td style={this.getQaNumColor(callbackSchedulingQaNum)}>
                  {callbackSchedulingQaNum}
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </Card>
    );
  }
}
